import styled from 'styled-components';

const MortgageBenefitsWrapper = styled.div<{ zIndex?: string; background?: string }>`
  position: relative;
  ${(props) => typeof props.zIndex !== 'undefined' && `z-index: ${props.zIndex}`};
  background: ${(props) => props.background || props.theme.backgroundLighter};
`;

export default MortgageBenefitsWrapper;
